module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAQBAMAAADdUfNzAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAYUExURUhs/zx2/zJ+/zx2/zx0/zx2/z54/z52//nsPvcAAAAHdFJOUwOvCqXBu0q9loHiAAAAMUlEQVQI12NIVGAAAnEBEKlaCCKZwpE57gYgSqUYImMAF4KIgJkQlWBdrIUI0xJBBABs4wdZJmI0lQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_icon_02_zh.png
// module id = vyMu
// module chunks = 34